(function() {
	'use strict';

	angular
		.module('directives')
		.directive('localeValidator', localeValidator);
	
	function localeValidator() {
		var directive = {
			require: 'ngModel',
			link: link
		};
		return directive;

		function link($scope, $element, $attrs, ctrl) {
			var validate = function(value) {
				var valid = false;
				if (value) {
					var parts = value.split('_');
					if (parts.length == 2) {
						if (parts[0].length == 2 && parts[1].length == 2) {
							if (parts[0] === parts[0].toLowerCase() && parts[1] === parts[1].toUpperCase()) {
								valid = true;
							}
						}
					}
				}
				ctrl.$setValidity('localeValidator', valid);
				return value;
			};

			ctrl.$parsers.unshift(validate);
			ctrl.$formatters.push(validate);

			$attrs.$observe('localeValidator', function(comparisonModel){
				return validate(ctrl.$viewValue);
			});
		}
	}
})();
